import { useState, useRef, useEffect } from "react";

import { Container, HiddenSample, ShowLessBtn, ShowMoreBtn } from "./style";

export const ShowMoreWrapper: React.FC<{ deps?: unknown }> = ({
  children,
  deps,
}) => {
  const [isRendered, setIsRendered] = useState<boolean>(false);
  const [isOverflow, setIsOverflow] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const sampleDescRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sampleDescRef.current) {
      if (
        sampleDescRef.current.clientHeight > 50 ||
        sampleDescRef.current.clientWidth > 878
      ) {
        setIsOverflow(true);
      } else {
        setIsOverflow(false);
        setIsOpen(false);
      }
      setIsRendered(true);
    }

    return () => {
      setIsRendered(false);
    };
  }, [deps]);

  return (
    <>
      {isRendered && (
        <>
          <Container isOpen={isOpen}>
            {children}
            {isOpen && isOverflow && (
              <ShowLessBtn
                onClick={(e) => {
                  setIsOpen(false);
                  e.stopPropagation();
                }}
              >
                less
              </ShowLessBtn>
            )}
          </Container>
          {!isOpen && isOverflow && (
            <ShowMoreBtn
              onClick={(e) => {
                setIsOpen(true);
                e.stopPropagation();
              }}
            >
              more
            </ShowMoreBtn>
          )}
        </>
      )}
      <HiddenSample ref={sampleDescRef}>{children}</HiddenSample>
    </>
  );
};
